module.exports = __webpack_public_path__ + "img/charge_text.769aff4f.png";